import React from "react";
import { StudentLevelSectionUIProvider } from "./StudentLevelSectionUIContext";
import { StudentLevelSectionCard } from "./StudentLevelSectionCard";

export function StudentLevelSectionPage({ history }) {
  const studentLevelSectionUIEvents = {
    openStudentAssignmentPage: () => {
      history.push("/ogrenci-kur-siniflari/ogrenci-atama");
    }
  };
  
  return (
    <StudentLevelSectionUIProvider studentLevelSectionUIEvents={studentLevelSectionUIEvents}>
      <StudentLevelSectionCard />
    </StudentLevelSectionUIProvider>
 );
}